import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import './CookieConsent.css';
import { defaultConsent } from '../utils/consentRegion';

const KEY = 'volcyy_analytics_consent';

function savedChoice() {
  try { const saved = localStorage.getItem(KEY); if (saved === 'granted' || saved === 'denied') return saved; } catch {}
  return defaultConsent();
}

export default function CookieConsent() {
  const [choice, setChoice] = useState(savedChoice);
  const [explicitChoice, setExplicitChoice] = useState(() => {
    try { return ['granted', 'denied'].includes(localStorage.getItem(KEY)); } catch { return false; }
  });
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const show = () => setOpen(true);
    window.addEventListener('volcyy:cookie-settings', show);
    return () => window.removeEventListener('volcyy:cookie-settings', show);
  }, []);

  useEffect(() => {
    // Keep Google's regional defaults intact until the visitor makes a choice.
    if (explicitChoice && (choice === 'granted' || choice === 'denied')) {
      window.gtag?.('consent', 'update', { analytics_storage: choice });
    }
  }, [choice, explicitChoice]);

  function choose(value) {
    try { localStorage.setItem(KEY, value); } catch { /* Consent still applies this visit. */ }
    setChoice(value);
    setExplicitChoice(true);
    setOpen(false);
  }

  if (choice && !open) return null;
  return (
    <aside className="cookie-consent" aria-label="Cookie choices">
      <div>
        <strong>Choose your cookies</strong>
        <p>Essential storage keeps the site working. With your permission, analytics helps us understand visits. You can change your choice in the footer. <Link to="/privacy">Privacy Policy</Link></p>
      </div>
      <div className="cookie-consent__actions">
        <button type="button" onClick={() => choose('denied')}>Reject analytics</button>
        <button type="button" className="cookie-consent__accept" onClick={() => choose('granted')}>Accept analytics</button>
      </div>
    </aside>
  );
}
